import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import classes from './SuggestionResult.module.scss.js';

const SuggestionResult = ({ geoOptionsLabels, query = '' }) => {
    const [label, extra] = geoOptionsLabels;
    let firstHalf;
    if (query.length > 0 && label.toLowerCase().startsWith(query.toLowerCase())) {
        firstHalf = (jsxs("span", { children: [jsx("b", { children: label.slice(0, query.length) }), label.slice(query.length)] }));
    }
    else {
        firstHalf = label;
    }
    return (jsxs(Fragment, { children: [firstHalf, extra != undefined ? (jsxs(Fragment, { children: ["\u00A0", jsx("span", { className: classes['location-qualifier'], children: extra })] })) : null] }));
};

export { SuggestionResult as default };
//# sourceMappingURL=SuggestionResult.js.map
